// @ts-ignore
import $ from 'jquery';

export default function layoutFullScreenEnable() {

    gd.bus.triggerEvent("full-screen:on");

    gd.layout.uiLeftNode.classList.add('full-screen-hidden')


    const $uiLayout = $("#ui-div-zero"); // center make full
    $uiLayout.addClass('full-screen');

    if (!gd.top.isEmpty) {
        gd.layout.top.fullScreen(true)
    }


}


// gd.bus.triggerEvent("full-screen:on");
//
// // this.left might be missing i.e. in widget mode
// this.left && this.left.hide(); // hide left
//
// const $uiLayout = $("#ui-div-zero"); // center make full
// $uiLayout.addClass('full-screen');
//
//
// if (!gd.top.isEmpty) {
//     gd.layout.top.fullScreen(true)
// }